module.exports = __webpack_public_path__ + "img/123.22e1921c.png";